import { Button } from '../components/ui/button';
import { TIMEZONE_OPTIONS } from './businessSettingsConstants';
import type { IBusinessProfileViewProps } from '@/@types/businessSettings';

export function BusinessProfileView({
  business,
  onEdit,
  onDelete,
  getIndustryLabel,
}: IBusinessProfileViewProps) {
  return (
    <div className="space-y-4 rounded-lg border p-6">
      <div className="flex items-start justify-between">
        <div>
          <h2 className="text-xl font-semibold">Your Business Profile</h2>
          <p className="text-sm text-muted-foreground">
            Last updated:{' '}
            {new Date(business.updatedAt).toLocaleDateString(undefined, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={onEdit}>
            Edit
          </Button>
          <Button variant="destructive" size="sm" onClick={onDelete}>
            Delete
          </Button>
        </div>
      </div>

      <div className="space-y-4 pt-4">
        <div>
          <p className="text-sm font-medium text-muted-foreground">Business Name</p>
          <p className="text-lg">{business.name}</p>
        </div>

        {business.brandName && (
          <div>
            <p className="text-sm font-medium text-muted-foreground">Brand Name</p>
            <p className="text-lg">{business.brandName}</p>
          </div>
        )}

        <div>
          <p className="text-sm font-medium text-muted-foreground">Industry</p>
          <p className="text-lg">{getIndustryLabel(business.industry)}</p>
        </div>

        {business.websiteUrl && (
          <div>
            <p className="text-sm font-medium text-muted-foreground">Website</p>
            <a
              href={business.websiteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-lg text-blue-600 dark:text-blue-400 underline underline-offset-4 hover:text-blue-800 dark:hover:text-blue-300"
            >
              {business.websiteUrl}
            </a>
          </div>
        )}

        {business.description && (
          <div>
            <p className="text-sm font-medium text-muted-foreground">Description</p>
            <p className="text-base whitespace-pre-wrap">{business.description}</p>
            {business.descriptionSource && (
              <p className="text-xs text-muted-foreground mt-1">
                Source: {business.descriptionSource === 'ai-generated' ? 'AI Generated' : 'Manual'}
                {business.descriptionConfidence &&
                  ` (${business.descriptionConfidence} confidence)`}
              </p>
            )}
          </div>
        )}

        <div>
          <p className="text-sm font-medium text-muted-foreground">Timezone</p>
          <p className="text-lg">
            {TIMEZONE_OPTIONS.find(tz => tz.value === (business.timezone ?? 'Europe/Nicosia'))
              ?.label ?? (business.timezone ?? 'Europe/Nicosia')}
          </p>
        </div>
      </div>
    </div>
  );
}
